import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '../interfaces/IError';
import { customAxiosInstance } from '../axios/axiosInstance';
import { IOrderControlRepository } from '../interfaces/IOrderControlRepository';
import {
  SortType,
  UseFilterItemForOrderControlManage,
  GetRecommendOrderIdsResponseResult,
  GetRecommendOrderIdsApi,
  GetApprovedRequestOrderIdsApi,
  GetApprovedRequestOrderIdsResponseResult,
} from '../axios/generated/orderControlManage';
import { axiosErrorHandler } from '../axios/axiosError';
import {
  GetOrderBusinessApi,
  ObjectFilterInfo,
  GetOrderBusinessResponseResult,
  OrderStatusFilterItemForOrderBusiness,
} from '../axios/generated/orderManage';
/**
 * 独自エラークラス
 */
class ExampleError extends Error {
  /**
   * コンストラクタ
   * @param number - エラー番号
   */
  constructor(number: string) {
    super(`Example API : 想定外のコード${number}が返却されました。`);
    this.name = 'ExampleError';
  }
}

/**
 * Axiosを使ったリポジトリ実装例
 * TODO: 一旦ダミーで実装
 */
export class OrderControlRepository implements IOrderControlRepository {
  /**
   * 発注情報の取得
   * filterを考えず、ソート、limit offsetのみ考える
   * @param sortType - ソートタイプ
   * @param limit - リミット
   * @param offset - オフセット
   * @param sortTarget - ソート対象のカラム名
   * @param filterItem - フィルタリングに使用する項目
   * @param filterItemInfo - フィルターの中で、Objectで渡す必要のあるもの
   * @param orderStatusFilterItem - 発注ステータスのフィルタリングに使用する項目
   * @param aggregateFreeColumns - 集計取引自由カラムのフィルター情報
   */
  async get(
    sortType: SortType,
    limit: number,
    offset: number,
    sortTarget?: string,
    filterItem?: UseFilterItemForOrderControlManage,
    filterItemInfo?: ObjectFilterInfo,
    orderStatusFilterItem?: OrderStatusFilterItemForOrderBusiness,
    aggregateFreeColumns?: string
  ): Promise<INetworkResult<GetOrderBusinessResponseResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderControlApi = new GetOrderBusinessApi(undefined, undefined, axiosInstance);

    // APIを叩く
    try {
      const apiResponse = await orderControlApi.getOrderBusiness(
        sortType,
        limit,
        offset,
        sortTarget,
        filterItem,
        filterItemInfo,
        orderStatusFilterItem,
        aggregateFreeColumns
      );
      switch (apiResponse.status) {
        case 200:
          const result: GetOrderBusinessResponseResult = apiResponse.data['result'];
          // return { status: { type: 'success', result: orderId } };
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 推奨情報を持っている集計IDを取得する
   * 推奨発注ID=推奨情報を持っている集計IDみたいな位置付け
   * @param filterItem - フィルタリングに使用する項目
   * @param filterItemInfo - フィルタリングに使用するオブジェクトで送る項目
   * @param aggregateFreeColumns - 集計取引自由カラムのフィルター情報
   */
  async getRecommendOrderIds(
    filterItem?: UseFilterItemForOrderControlManage,
    filterItemInfo?: ObjectFilterInfo,
    aggregateFreeColumns?: string
  ): Promise<INetworkResult<GetRecommendOrderIdsResponseResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const getRecommendOrderIdsApi = new GetRecommendOrderIdsApi(undefined, undefined, axiosInstance);

    // APIを叩く
    try {
      const apiResponse = await getRecommendOrderIdsApi.getRecommendOrderIds(filterItem, filterItemInfo, aggregateFreeColumns);
      switch (apiResponse.status) {
        case 200:
          const result: GetRecommendOrderIdsResponseResult = apiResponse.data['result'];
          // return { status: { type: 'success', result: orderId } };
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 承認済み情報を持っている集計IDを取得する
   * @param filterItem - フィルタリングに使用する項目
   * @param filterItemInfo - フィルタリングに使用するオブジェクトで送る項目
   * @param aggregateFreeColumns - 集計取引自由カラムのフィルター情報
   */
  async getApprovedRequestOrderIds(
    filterItem?: UseFilterItemForOrderControlManage,
    filterItemInfo?: ObjectFilterInfo,
    aggregateFreeColumns?: string
  ): Promise<INetworkResult<GetApprovedRequestOrderIdsResponseResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const getApprovedRequestOrderIdsApi = new GetApprovedRequestOrderIdsApi(undefined, undefined, axiosInstance);

    // APIを叩く
    try {
      const apiResponse = await getApprovedRequestOrderIdsApi.getApprovedRequestOrderIds(filterItem, filterItemInfo, aggregateFreeColumns);
      switch (apiResponse.status) {
        case 200:
          const result: GetApprovedRequestOrderIdsResponseResult = apiResponse.data['result'];
          // return { status: { type: 'success', result: orderId } };
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
}
